import React, { useRef, useState } from 'react';
import { FormGenericContainer } from '../FormGenericContainer';
import { BubbleButton } from '../BubbleUI';
import { VenueTemplate } from '@go-shared/types/venueTemplate';
import { Alert } from '@spark-labs/avocado-ui';
import { BareContentTemplate } from '@go-shared/types/contentTemplate';
import { Content } from '@go-shared/types/content';
import ContentFormik, {
  ContentFormikExtState,
  ContentFormikMode,
  ContentFormikRef,
} from '../Formik/ContentFormik';
import { Plan } from '@go-shared/types/plan';
import { ContentTemplateTranslation } from '@go-shared/types/translation';

interface ModifyEventDetailsPageProps {
  mode: ContentFormikMode;
  plan: Plan;
  selectedCntTemplate: BareContentTemplate;
  contentTemplateTranslations: ContentTemplateTranslation[];
  title: string;
  submitTitle: string;
  venueTemplates: VenueTemplate[];
  onGoBack?: () => void;
  onClose?: () => void;
  onDelete?: (contentdId: string) => void;
  onSubmit?: (content: Content) => void;
}

export default function ModifyContentDetailsPage(props: ModifyEventDetailsPageProps) {
  const { mode, plan, selectedCntTemplate, venueTemplates, contentTemplateTranslations } = props;

  const [formikState, setFormikState] = useState<ContentFormikExtState | undefined>(undefined);

  const formikRef = useRef<ContentFormikRef>(null);

  return (
    <div className="cef-2">
      <FormGenericContainer
        className="absolute top-0 left-0 w-full h-full flex flex-col"
        bodyClassName="p-0-i flex-grow relative bg-eggshell"
        footerClassName="p-4-i border-t"
        footer={() => (
          <>
            {selectedCntTemplate && (
              <div className="text-slate-dark">
                <div>
                  Template Selected:
                  <span className="font-semibold"> {selectedCntTemplate.name}</span>
                </div>
              </div>
            )}
            <div className="ml-auto" />
            <BubbleButton variant="navy" inverse onClick={props.onGoBack}>
              Go Back
            </BubbleButton>
            {mode.type === 'edit' && (
              <BubbleButton
                variant="crimson"
                inverse
                onClick={async () => {
                  if (mode.edit?._id && props.onDelete) {
                    const yes = await Alert.question(
                      'Are you sure you wish to delete this content from the canvas?'
                    );
                    if (!yes) return;
                    props.onDelete(mode.edit._id);
                  }
                }}
                icon="trash-alt"
              >
                Delete Content
              </BubbleButton>
            )}
            <BubbleButton
              disabled={formikState?.disabled}
              onClick={formikRef.current?.submit}
              variant="navy"
            >
              {props.submitTitle}
            </BubbleButton>
          </>
        )}
      >
        <div className="p-6">
          <div className="flex items-start mb-8">
            <div>
              <h1 className="text-lg text-slate-dark font-semibold">{props.title}</h1>
              <h2 className="text-2xl text-navy">2. Enter Day Details</h2>
            </div>
            <BubbleButton
              onClick={props.onClose}
              className="ml-auto"
              variant="navy"
              inverse
              icon="xmark-large"
              iconSize="xl"
            />
          </div>
          <ContentFormik
            ref={formikRef}
            mode={mode}
            venueTemplates={venueTemplates}
            onStateUpdate={setFormikState}
            template={selectedCntTemplate}
            contentTemplateTranslations={contentTemplateTranslations}
            plan={plan}
            onSubmit={props.onSubmit}
            actionsClassName="hidden"
          />
        </div>
      </FormGenericContainer>
    </div>
  );
}
